export default __webpack_public_path__ + "static/hw_ff_potentiometer_schem-021669892ccae5aef47ed7d976a287dc.png";